import {Box} from '@customink/pigment-react';
import React from 'react';

export default function OutOfStockBanner() {
  return (
    <Box
      sx={{
        backgroundColor: '#615f5f',
        borderRadius: '0.25rem',
        color: 'rgba(255,255,255,0.8)',
        fontSize: '0.875rem',
        fontWeight: 'bold',
        left: '50%',
        letterSpacing: '0.0625rem',
        margin: '0 auto',
        padding: '0.5rem',
        position: 'absolute',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        whiteSpace: 'nowrap',
        zIndex: 101
      }}>
      OUT OF STOCK
    </Box>
  );
}
